import type { EditorDoc } from '@roomtreatment/core';

// Geometry signature: room dimensions + footprint + wings + ceiling + the
// furniture that displaces air.  Materials and furnishing stay excluded — they
// don't change the bare-room eigensolve (they enter only via per-mode-Q
// downstream).  Furniture IS included: a solid piece carves SOLID voxels, so
// moving / resizing / swapping it changes the eigenmodes and must re-arm.
// (presetId stands in for material+kind; both derive from it.)
export function geometrySignature(doc: EditorDoc): string {
  return JSON.stringify({
    dims: [doc.dims.Lx, doc.dims.Ly, doc.dims.H],
    roomShape: doc.roomShape ?? null,
    footprint: doc.footprint ?? null,
    wings: doc.wings ?? null,
    ceiling: doc.ceiling ?? null,
    furniture: (doc.furniture ?? []).map((f) => ({
      p: f.presetId,
      s: [f.size.w, f.size.h, f.size.d],
      x: f.position,
      r: f.rotation,
    })),
  });
}
